const adaptData = ({ links }, location) => {
    const { pathname } = location;
    const parts = pathname.split('/').filter(part => part != '');
    const currentSection = parts[1];

    return {
        links,
        currentSection
    }
};

export default adaptData;
